<nav mat-tab-nav-bar>
    <a mat-tab-link routerLink="overview" routerLinkActive #over="routerLinkActive" [active]="over.isActive">Overview</a>
    <a mat-tab-link routerLink="settings" routerLinkActive #sett="routerLinkActive" [active]="sett.isActive">Settings</a>
</nav>
<div class="content">
    <router-outlet></router-outlet>
</div>
